import React, { useState, useEffect } from "react";
import "./Wishlist.css";
import { useSelector, useDispatch } from "react-redux";
import { MdOutlineClose } from "react-icons/md";
import { Link } from "react-router-dom";
import {
  addToWishList,
  removeFromWishList,
  clearWishList,
} from "../../Features/Wishlist/wishListSlice";

const isPreciousMetal = (metalType) => {
  const preciousMetals = ['Gold', 'Rose Gold', 'Platinum', 'White Gold'];
  return preciousMetals.includes(metalType);
};

const Wishlist = () => {
  const wishlistItems = useSelector((state) => state.wishlist.items);
  const dispatch = useDispatch();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleRemoveFromWishList = (item) => {
    dispatch(removeFromWishList(item));
  };

  const handleClearWishList = () => {
    dispatch(clearWishList());
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="wishlistSection">
      <h2>Wishlist</h2>
      <div className="wishlistTableSection">
        {/* Conditionally render based on screen size */}
        {isMobile ? (
          // Mobile View
          <div className="wishlistTableMobile">
            {wishlistItems.length > 0 ? (
              <>
                {wishlistItems.map((item) => (
                  <div key={item.id}>
                    <div className="wishlistTableMobileItems">
                      <div className="wishlistTableMobileItemsImg">
                        <Link to="/product" onClick={scrollToTop}>
                          <img src={item.frontImg} alt={item.name} />
                        </Link>
                      </div>
                      <div className="wishlistTableMobileItemsDetail">
                        <div className="wishlistTableMobileItemsDetailMain">
                          <Link to={`/product/${item.productID}`} onClick={scrollToTop}>
                            <h4>{item.productName}</h4>
                          </Link>
                          <p>{item.category}</p>
                          <span>${item.productPrice}</span>
                        </div>
                        <div className="wishlistTableMobileActions">
                          <button>Add to Cart</button>
                          <MdOutlineClose
                            size={20}
                            onClick={() => handleRemoveFromWishList(item)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </>
            ) : (
              <div className="wishlistEmpty">
                <span>Your wishlist is empty!</span>
                <Link to="/shop" onClick={scrollToTop}>
                  <button>Shop Now</button>
                </Link>
              </div>
            )}
          </div>
        ) : (
          // Desktop View
          <table className="wishlistTable">
            <thead>
              <tr>
                <th>Product</th>
                <th></th>
                <th>Price</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {wishlistItems.length > 0 ? (
                wishlistItems.map((item) => (
                  <tr key={item.id}>
                    <td data-label="Product">
                      <div className="wishlistTableImg">
                        <Link to="/product" onClick={scrollToTop}>
                            <img src={item.frontImg} alt={item.name} />
                        </Link>
                      </div>
                    </td>
                    <td data-label="">
                      <div className="wishlistTableProductDetail">
                        <Link to="/product" onClick={scrollToTop}>
                          <h4>{item.productName}</h4>
                        </Link>
                        <p>{item.category}</p>
                      </div>
                    </td>
                    <td data-label="Price" className="wishlistTablePrice">
                    {isPreciousMetal(item.metalType) ? (
                            <span style={{ color: "#767676", fontWeight: "500" }}>
                              Price on inquiry
                            </span>
                          ) : (
                            <>
                              {item.isOnSale ? (
                                <>
                                  <span style={{ color: "#a52a2a", fontWeight: "500" }}>
                                    ${item.productPrice}
                                  </span>
                                  &nbsp;
                                  <span
                                    style={{
                                      color: "#767676",
                                      textDecoration: "line-through",
                                      textDecorationThickness: "1px"
                                    }}
                                  >
                                    ${item.originalPrice}
                                  </span>
                                </>
                              ) : (
                                <span style={{ color: "#767676" }}>
                                  ${item.productPrice}
                                </span>
                              )}
                            </>
                          )}
                    </td>
                    <td data-label="Actions">
                      <div className="wishlistTableActions">
                      {isPreciousMetal(item.metalType) ? (
                      <Link to="/contact">  
                        <button >
                          Enquire Now
                        </button>
                      </Link>  
                      ) : (
                        <button className="add-to-cart-button">Add to Cart</button>
                      )}

                        <MdOutlineClose
                          onClick={() => handleRemoveFromWishList(item)}
                        />
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4">
                    <div className="wishlistEmpty">
                      <span>Your wishlist is empty!</span>
                      <Link to="/shop" onClick={scrollToTop}>
                        <button>Shop Now</button>
                      </Link>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </div>

      {/* Clear Wishlist Button */}
      {wishlistItems.length > 0 && (
        <div className="clearWishlistButton">
          <button onClick={handleClearWishList}>Clear Wishlist</button>
        </div>
      )}
    </div>
  );
};

export default Wishlist;